window.VFMaterialWeight = {
  gramsPerPound: 453.59237,
  calculate(variant, requestedLength, productTitle = '') {
    const requested = Number(requestedLength);
    if (!Number.isFinite(requested) || requested <= 0) return null;
    const rate = Number(variant.shippingGramsPerInch);
    let grams;
    let basis;
    if (Number.isFinite(rate) && rate > 0) {
      grams = requested * rate;
      basis = 'Configured weight per inch';
    } else {
      const material = `${variant.alloy || ''} ${productTitle}`.toLowerCase();
      let density;
      // Merchant calculator: Damtanium Zirmascus Stellite!E9, lb/in³.
      if (/zirmascus|zirconium/.test(material)) density = 0.177;
      else if (/damtanium|titanium/.test(material)) density = 0.167;
      else if (/mokume|brass|nickel.?silver/.test(material)) density = 0.310;
      else if (/darkfire|copperhead|copper.?infused/.test(material)) density = 0.280;
      else if (/stellite/.test(material)) density = 0.336;
      else if (/round/i.test(variant.materialForm || '') && /304.*316|bold twist/.test(material)) density = 0.290;
      else if (/stainless|carbon|damascus|san mai/.test(material)) density = 0.280;
      else return null;
      const round = /round/i.test(variant.materialForm || '');
      const width = Number(variant.width);
      const thickness = Number(variant.thickness);
      const diameter = Number(variant.diameter);
      if (round && (!Number.isFinite(diameter) || diameter <= 0)) return null;
      if (!round && (!Number.isFinite(width) || width <= 0 || !Number.isFinite(thickness) || thickness <= 0)) return null;
      const area = round ? Math.PI * diameter * diameter / 4 : width * thickness;
      grams = requested * area * density * this.gramsPerPound;
      basis = 'Dimensions and approximate material density';
    }
    if (!Number.isFinite(grams) || grams <= 0) return null;
    grams = Math.ceil(grams - 1e-9);
    return { grams, pounds: grams / this.gramsPerPound, basis };
  },
};

if (!customElements.get('vf-cut-selector')) {
  class VfCutSelector extends HTMLElement {
    connectedCallback() {
      this.defaultCutAllowance = Number(this.dataset.cutAllowance || 0.1);
      this.materialForm = this.dataset.materialForm || 'flat';
      this.roundMinRemnant = Number(this.dataset.roundMinRemnant || 0.5);
      this.priceMode = this.dataset.priceMode || 'full_billet';
      this.checkoutEnabled = this.dataset.checkoutEnabled === 'true';
      this.currency = this.dataset.currency || 'USD';
      this.money = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency });
      this.variants = JSON.parse(this.querySelector('[data-vf-cut-variants]').textContent).map((variant) => this.normalizeVariant(variant));
      this.alloysEl = this.querySelector('[data-vf-alloys]');
      this.billetsEl = this.querySelector('[data-vf-billets]');
      this.lengthInput = this.querySelector('[data-vf-length]');
      this.fullInput = this.querySelector('[data-vf-full]');
      this.validationEl = this.querySelector('[data-vf-validation]');
      this.mathEl = this.querySelector('[data-vf-math]');
      this.totalEl = this.querySelector('[data-vf-total]');
      this.specialSavingEl = this.querySelector('[data-vf-special-saving]');
      this.rateEl = this.querySelector('[data-vf-rate]');
      this.submit = this.querySelector('[data-vf-submit]');
      this.form = this.querySelector('[data-vf-form]');
      this.controlsEl = this.querySelector('[data-vf-controls]');
      this.soldOutEl = this.querySelector('[data-vf-sold-out]');
      this.dpoReady = false;
      this.dpoLoading = true;
      this.currentTotalCents = 0;
      this.syncedVariantId = null;
      const availableVariants = this.variants.filter((variant) => variant.available);

      if (!availableVariants.length) {
        this.controlsEl.hidden = true;
        this.soldOutEl.hidden = false;
        this.setAttribute('data-sold-out', 'true');
        this.setAttribute('data-ready', 'true');
        return;
      }

      const requestedId = new URL(window.location.href).searchParams.get('variant');
      const preferred = availableVariants.find((variant) => String(variant.id) === requestedId)
        || availableVariants.find((variant) => /stainless/i.test(variant.alloy))
        || availableVariants[0];
      this.activeAlloy = preferred.alloy;
      this.activeVariant = preferred;
      this.bindEvents();
      this.bindDpo();
      this.bindSubmitObserver();
      this.renderAlloys();
      this.renderBillets();
      this.resetLength();
      this.setAttribute('data-ready', 'true');
    }

    disconnectedCallback() {
      this.submitObserver?.disconnect();
    }

    normalizeVariant(variant) {
      const parsed = this.parseDimensions(variant.dimensions || variant.title);
      const availableLength = Number(variant.availableLength);
const physicalLength = Number.isFinite(availableLength) ? availableLength : parsed.length || 0;
      const materialForm = variant.materialForm || this.materialForm;
      const pricePerInch = Number(variant.pricePerInch) > 0
        ? Number(variant.pricePerInch) * 100
        : physicalLength > 0 ? Number(variant.priceCents) / physicalLength : 0;
      const fullBilletPrice = pricePerInch > 0 && physicalLength > 0
  ? pricePerInch * physicalLength
  : Number(variant.fullBilletPrice) > 0
    ? Number(variant.fullBilletPrice) * 100
    : Number(variant.priceCents) || 0;
      const cutAllowance = Number(variant.cutAllowance) > 0
        ? Number(variant.cutAllowance)
        : this.defaultCutAllowance;
      // Flat billets may leave any remainder; keep the existing round-stock rule.
      const minimumRemnant = materialForm === 'round'
        ? Number(variant.minimumRemnant) > 0 ? Number(variant.minimumRemnant) : this.roundMinRemnant
        : 0;
      const sellingIncrement = Number(variant.sellingIncrement) > 0 ? Number(variant.sellingIncrement) : 1;
      const cutEnabled = variant.cutEnabled === null || variant.cutEnabled === undefined
        ? true
        : Boolean(variant.cutEnabled);
      return {
        ...variant,
        alloy: variant.alloy || 'Standard',
        materialForm,
        weightReferenceLength: parsed.length || physicalLength,
        length: physicalLength,
        thickness: Number(variant.thickness) || parsed.thickness,
        width: Number(variant.width) || parsed.width,
        diameter: Number(variant.diameter) || parsed.diameter,
        specialPercent: Math.max(0, Math.min(99, Number(variant.specialPercent) || 0)),
        regularPricePerInch: Math.max(0, Number(variant.regularPricePerInch) || 0) * 100,
        pricePerInch,
        fullBilletPrice,
        cutAllowance,
        minimumRemnant,
        sellingIncrement,
        available: Boolean(variant.available) && cutEnabled && physicalLength > 0,
      };
    }

    parseDimensions(value) {
      const numbers = String(value || '').match(/(?:\d+\.?\d*|\.\d+)/g)?.map(Number) || [];
      if (this.materialForm === 'round') return { length: numbers[0] || 0, diameter: numbers[1] || 0, width: 0, thickness: 0 };
      return { length: numbers[0] || 0, width: numbers[1] || 0, thickness: numbers[2] || 0, diameter: 0 };
    }

    bindEvents() {
      this.querySelector('[data-vf-minus]').addEventListener('click', () => {
        if (this.requiresFullBillet()) return this.update();
        this.fullInput.checked = false;
        this.lengthInput.disabled = false;
        this.lengthInput.value = Math.max(this.activeVariant.sellingIncrement, Number(this.lengthInput.value || this.activeVariant.sellingIncrement) - this.activeVariant.sellingIncrement);
        this.update();
      });
      this.querySelector('[data-vf-plus]').addEventListener('click', () => {
        if (this.requiresFullBillet()) return this.update();
        this.fullInput.checked = false;
        this.lengthInput.disabled = false;
        this.lengthInput.value = Number(this.lengthInput.value || 0) + this.activeVariant.sellingIncrement;
        this.update();
      });
      this.lengthInput.addEventListener('input', () => {
        if (this.requiresFullBillet()) return this.update();
        this.fullInput.checked = false;
        this.lengthInput.disabled = false;
        this.update();
      });
      this.fullInput.addEventListener('change', () => {
        this.lengthInput.disabled = this.fullInput.checked;
        this.update();
      });
      const guardPurchase = (event) => {
        if (event.type === 'click' && !event.target.closest('[data-vf-submit]')) return;
        if (this.pendingPurchase) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        this.update();
        this.bindPurchaseHandoff();
        if (!this.isValid() || !this.isShippingReady()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.update();
        }
      };
      this.form.addEventListener('submit', guardPurchase, true);
      this.form.addEventListener('click', guardPurchase, true);
    }

    bindDpo() {
      const initialize = () => {
        this.bindPurchaseHandoff();
        this.dpoReady = Boolean(document.querySelector('#itoris_dynamicproductoptions .pr input'));
        const ready = this.dpoReady && Boolean(document.querySelector('#itoris_dynamicproductoptions .vf-weight-grams input'));
        if (ready) this.dpoLoading = false;
        this.update();
        return ready;
      };

      const poll = (attempt = 0) => {
        if (initialize()) return;
        if (attempt >= 40) {
          this.dpoLoading = false;
          this.update();
          return;
        }
        window.setTimeout(() => poll(attempt + 1), 250);
      };

      if (window.jQuery) {
        window.jQuery(window).on('dpo_initialized.vfCutSelector', initialize);
      }

      poll();
    }

    bindPurchaseHandoff() {
      const jq = window.jQuery;
      const options = window.dpoOptions;
      if (!jq || !options || !window.dpoObserver || (options.vfCutValidation && options.customValidation === options.vfCutValidation)) return;
      const previousValidation = options.customValidation;
      options.customValidation = (...args) => {
        if (this.pendingPurchase) return false;
        this.update();
        if (!this.isValid() || !this.isShippingReady()) return false;
        if (previousValidation && previousValidation.apply(options, args) === false) return false;
        if (options.validateForm && options.validateForm() === false) return false;
        options.skipVariantCreation = false;
        options.skipAddToCartDelay = 0;
        window.dpoObserver.directAddToCartSubmit = 2;
        this.pendingPurchase = Object.freeze({
          variantId: String(this.activeVariant.id),
          properties: Object.freeze(Object.fromEntries(
            [...this.form.querySelectorAll('input[name^="properties["]')]
              .filter((input) => [...input.attributes].some((attr) => attr.name.startsWith('data-vf-property-')))
              .map((input) => [input.name, input.value])
          )),
        });
        this.variantSyncRevision = (this.variantSyncRevision || 0) + 1;
        this.purchaseControls = [...this.querySelectorAll('button, [data-vf-length], [data-vf-full]')]
          .map((control) => ({ control, disabled: control.disabled }));
        this.purchaseControls.forEach(({ control }) => { control.disabled = true; });
        const retry = this.retryableCut;
        this.retryableCut = null;
        if (retry && Date.now() - retry.createdAt < 300000
          && retry.purchase.variantId === this.pendingPurchase.variantId
          && JSON.stringify(retry.purchase.properties) === JSON.stringify(this.pendingPurchase.properties)) {
          this.resumePreparedCut(retry, options);
          return false;
        }
        return true;
      };
      options.vfCutValidation = options.customValidation;
      if (options.asyncAddToCart !== options.vfCutAdd) {
        const previousAdd = options.asyncAddToCart;
        options.vfCutAdd = (formData, variantId, attempt) => this.pendingPurchase
          ? this.addPreparedCut(formData, variantId, options)
          : previousAdd.call(options, formData, variantId, attempt);
        options.asyncAddToCart = options.vfCutAdd;
      }
      jq(window).off('dpo_before_form_submit.vfCutPayload').on('dpo_before_form_submit.vfCutPayload', (_event, temp) => {
        const form = temp?.tagName === 'FORM' ? temp : temp?.[0];
        this.preparePurchaseForm(form);
      });
      jq(document).off('ajaxComplete.vfCutPurchase').on('ajaxComplete.vfCutPurchase', (_event, xhr, settings) => {
        if (!this.pendingPurchase || settings.url !== window.dpoObserver.formValidateUrl) return;
        const response = xhr.responseJSON;
        if (xhr.status < 200 || xhr.status >= 300 || response?.error || response?.notice || !response?.variant_id) this.finishPurchase();
      });
    }

    preparePurchaseForm(form) {
      if (!this.pendingPurchase || !form || Number(window.dpoObserver?.directAddToCartSubmit) !== 2) return;
      const formData = window.jQuery(form).prop('formData');
      if (!(formData instanceof FormData)) throw new Error('Cut submission data unavailable');
      for (const [name, value] of Object.entries(this.pendingPurchase.properties)) {
        [...form.elements].filter((input) => input.name === name).forEach((input) => input.remove());
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.append(input);
        formData.set(name, value);
      }
      formData.set('quantity', '1');
    }

    resumePreparedCut(retry, options) {
      const form = document.createElement('form');
      form.id = 'dpo_tmp_form';
      form.hidden = true;
      const formData = new FormData();
      for (const [name, value] of retry.formData.entries()) {
        formData.append(name, value);
        if (typeof value !== 'string') continue;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.append(input);
      }
      document.body.append(form);
      window.jQuery(form).prop('formData', formData);
      window.jQuery(window).trigger('dpo_before_form_submit', window.jQuery(form));
      void this.addPreparedCut(formData, retry.variantId, options, retry.createdAt);
    }

    addPreparedCut(formData, variantId, options, createdAt = Date.now()) {
      if (this.purchaseRequest) return this.purchaseRequest;
      const purchase = this.pendingPurchase;
      formData.set('id', String(variantId));
      const root = window.Shopify?.routes?.root || '/';
      const matches = (item) => String(item.variant_id || item.id) === String(variantId)
        && Object.entries(purchase.properties).every(([name, value]) => item.properties?.[name.slice(11, -1)] === value);
      const quantity = (cart) => cart.items.filter(matches).reduce((sum, item) => sum + Number(item.quantity), 0);
      const request = async (url, init = {}) => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...init, signal: controller.signal });
          const data = await response.json();
          return { response, data };
        } finally { clearTimeout(timer); }
      };
      const readCart = async () => {
        const { response, data } = await request(`${root}cart.js?_vf_cut_check=${Date.now()}`);
        if (!response.ok || !Array.isArray(data.items)) throw new Error('Cart unavailable');
        return data;
      };
      const complete = (data) => {
        options.addDPOP(data);
        options.asyncAddToCartPostCheck(variantId, data);
      };
      const run = async () => {
        let baseline;
        try { baseline = quantity(await readCart()); }
        catch { throw new Error('Your cart could not be checked. Please try again.'); }
        for (let attempt = 0; attempt < 4; attempt++) {
          let result;
          try { result = await request(root + 'cart/add.js', { method: 'POST', body: formData }); }
          catch { /* An uncertain POST must be reconciled, never blindly repeated. */ }
          if (result?.response.ok && String(result.data.id || result.data.variant_id) === String(variantId)) {
            complete(result.data);
            return;
          }
          try {
            const cart = await readCart();
            if (quantity(cart) >= baseline + 1) {
              complete(cart.items.find(matches));
              return;
            }
          } catch { /* Keep the uncertain result blocked. */ }
          const message = String(result?.data?.description || result?.data?.message || '');
          const justCreated = result?.response.status === 422 && /^Cannot find variant\.?$/i.test(message.trim());
          if (justCreated && attempt < 3) {
            await new Promise((resolve) => setTimeout(resolve, 2000 * (2 ** attempt)));
            continue;
          }
          if (justCreated) {
            this.retryableCut = { purchase, formData, variantId, createdAt };
            throw new Error('Your cut is still being prepared. Select Retry add to cart to continue with the same cut.');
          }
          if (result && [400, 404, 422, 429].includes(result.response.status)) {
            throw new Error(message.replace(/\s*\(D#[^)]+\)/g, '') || 'This cut could not be added. Please review your selection.');
          }
          throw new Error('We could not confirm whether this cut was added. Please view your cart before trying again.');
        }
      };
      this.querySelectorAll('[data-vf-submit]').forEach((button) => { button.textContent = 'ADDING TO CART…'; });
      this.purchaseRequest = run().catch((error) => {
        options.vfCutRestoreConfirmation?.();
        if (document.querySelector('[name="id_prev"]')) {
          document.querySelectorAll('[name="id"]').forEach((input) => input.remove());
          document.querySelectorAll('[name="id_prev"]').forEach((input) => { input.name = 'id'; });
        }
        document.querySelectorAll('#dpo-cart-properties, #dpo_tmp_form').forEach((element) => element.remove());
        this.querySelectorAll('.submitting').forEach((element) => element.classList.remove('submitting'));
        this.finishPurchase();
        this.syncedVariantId = null;
        this.update();
        this.validationEl.textContent = error.message;
        this.validationEl.hidden = false;
        if (this.retryableCut) this.querySelectorAll('[data-vf-submit]').forEach((button) => { button.textContent = 'RETRY ADD TO CART'; });
      }).finally(() => { this.purchaseRequest = null; });
      return this.purchaseRequest;
    }

    finishPurchase() {
      this.pendingPurchase = null;
      this.purchaseControls?.forEach(({ control, disabled }) => { control.disabled = disabled; });
      this.purchaseControls = null;
    }

    bindSubmitObserver() {
      this.submitObserver = new MutationObserver((mutations) => {
        // DPO removes this class after its final failed add attempt. Release
        // the selection lock only then, not during its internal retries.
        const submissionEnded = mutations.some((mutation) => mutation.type === 'attributes'
          && String(mutation.oldValue || '').split(/\s+/).includes('submitting')
          && !mutation.target.classList.contains('submitting'));
        if (this.pendingPurchase && submissionEnded) this.finishPurchase();
        const submitAdded = mutations.some((mutation) => [...mutation.addedNodes].some((node) => (
          node.nodeType === Node.ELEMENT_NODE
          && (node.matches?.('[data-vf-submit]') || node.querySelector?.('[data-vf-submit]'))
        )));
        if (submitAdded) this.update();
      });
      this.submitObserver.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'], attributeOldValue: true });
    }

    renderAlloys() {
      const alloys = [...new Set(this.variants.filter((variant) => variant.available).map((variant) => variant.alloy))].sort((a, b) => /stainless/i.test(a) ? -1 : /stainless/i.test(b) ? 1 : a.localeCompare(b));
      this.alloysEl.innerHTML = alloys.map((alloy) => {
        const group = this.variants.filter((variant) => variant.alloy === alloy);
        const count = group.filter((variant) => variant.available).length;
        return `<button type="button" class="vf-cut__alloy ${alloy === this.activeAlloy ? 'is-selected' : ''}" data-alloy="${this.escape(alloy)}" ${count ? '' : 'disabled'}><strong>${this.escape(alloy)}</strong><small>${count ? `${count} billet${count === 1 ? '' : 's'} available` : 'Out of stock'}</small></button>`;
      }).join('');
      this.alloysEl.querySelectorAll('[data-alloy]').forEach((button) => button.addEventListener('click', () => {
        this.activeAlloy = button.dataset.alloy;
        this.activeVariant = this.variants.find((variant) => variant.available && variant.alloy === this.activeAlloy);
        this.renderAlloys();
        this.renderBillets();
        this.resetLength();
      }));
    }

    renderBillets() {
      const group = this.variants.filter((variant) => variant.alloy === this.activeAlloy);
      this.billetsEl.innerHTML = group.map((variant) => {
        const selected = variant.id === this.activeVariant?.id;
        const size = variant.materialForm === 'round' || variant.materialForm === 'round_bar'
          ? `${this.dimension(variant.diameter)}″ OD`
          : `${this.dimension(variant.thickness, true)}″ × ${this.dimension(variant.width)}″`;
        return `<button type="button" class="vf-cut__billet ${selected ? 'is-selected' : ''}" data-variant-id="${variant.id}" ${variant.available ? '' : 'disabled'}><span class="vf-cut__radio"></span><span class="vf-cut__billet-size"><strong>${size}</strong><small>${this.length(variant.length)}″ available · SKU ${this.escape(variant.sku || '—')}</small>${variant.coreMaterial ? `<small>Core: ${this.escape(variant.coreMaterial)}</small>` : ''}</span><span class="vf-cut__billet-price">${variant.specialPercent > 0 && variant.regularPricePerInch > variant.pricePerInch ? `<span class="vf-special-badge">${this.escape(this.dataset.specialSave)} ${variant.specialPercent}%</span><s>${this.money.format(variant.regularPricePerInch / 100)}</s>` : ''}<strong>${this.money.format(variant.pricePerInch / 100)}</strong><small>per inch</small></span></button>`;
      }).join('');
      this.billetsEl.querySelectorAll('[data-variant-id]').forEach((button) => button.addEventListener('click', () => {
        this.activeVariant = this.variants.find((variant) => String(variant.id) === button.dataset.variantId);
        this.renderBillets();
        this.resetLength();
      }));
    }

    resetLength() {
      if (!this.activeVariant) return;
      const maxPartial = this.maximumPartialLength();
      this.fullInput.checked = this.requiresFullBillet() || maxPartial < this.activeVariant.sellingIncrement;
      this.lengthInput.disabled = this.fullInput.checked;
      this.lengthInput.min = this.activeVariant.sellingIncrement;
      this.lengthInput.step = this.activeVariant.sellingIncrement;
      this.lengthInput.value = this.fullInput.checked ? this.activeVariant.length : Math.min(8, maxPartial);
      this.update();
    }

    requiresFullBillet() {
      return this.activeVariant.length <= 7;
    }

    maximumPartialLength() {
      if (this.requiresFullBillet()) return 0;
      const variant = this.activeVariant;
      const available = variant.length - variant.cutAllowance - variant.minimumRemnant;
      return Math.max(0, Math.floor((available + 1e-9) / variant.sellingIncrement) * variant.sellingIncrement);
    }

    result() {
      const full = this.requiresFullBillet() || this.fullInput.checked;
      const requested = full ? this.activeVariant.length : Number(this.lengthInput.value);
      const remaining = full ? 0 : this.activeVariant.length - requested - this.activeVariant.cutAllowance;
      const units = requested / this.activeVariant.sellingIncrement;
      const validIncrement = full || Math.abs(units - Math.round(units)) < 1e-9;
      const validRange = requested > 0 && requested <= this.activeVariant.length;
      const validRemnant = full || remaining + 1e-9 >= this.activeVariant.minimumRemnant;
      return { full, requested, remaining: Math.max(0, remaining), validIncrement, validRange, validRemnant, valid: validIncrement && validRange && validRemnant };
    }

    totalForResult(result, variant = this.activeVariant) {
      // Avoid binary floating-point ties rounding a half-cent down.
      return Math.round((result.full ? variant.fullBilletPrice : result.requested * variant.pricePerInch) + 1e-7);
    }

    isValid() { return Boolean(this.activeVariant && this.result().valid); }

    isShippingReady() {
      if (!this.currentMaterialWeight || !this.dpoReady || !this.syncDpoPrice()) return false;
      const price = document.querySelector('#itoris_dynamicproductoptions .pr input');
      const weight = document.querySelector('#itoris_dynamicproductoptions .vf-weight-grams input');
      return Boolean(price && weight && Math.round(Number(price.value) * 100) === this.currentTotalCents
        && Number(weight.value) === this.currentMaterialWeight.grams);
    }

    update() {
      if (!this.activeVariant || this.pendingPurchase) return;
      const fullRequired = this.requiresFullBillet();
      if (fullRequired) {
        this.fullInput.checked = true;
        this.lengthInput.value = this.activeVariant.length;
      }
      this.querySelector('[data-vf-full-notice]').hidden = !fullRequired;
      this.fullInput.disabled = fullRequired;
      this.lengthInput.disabled = this.fullInput.checked;
      this.querySelector('[data-vf-minus]').disabled = fullRequired;
      this.querySelector('[data-vf-plus]').disabled = fullRequired;
      const result = this.result();
      const variant = this.activeVariant;
      this.querySelector('[data-vf-full-copy]').textContent = `Get the entire ${this.length(this.activeVariant.length)}″ billet`;
      this.querySelector('[data-vf-rule-copy]').textContent = fullRequired
        ? this.dataset.fullRequiredMessage
        : `Sold in ${this.length(variant.sellingIncrement)}″ increments.`;
      if (!result.valid) {
        this.validationEl.hidden = false;
        if (!result.validIncrement) this.validationEl.innerHTML = `<strong>Please enter a valid length.</strong>This material is sold in ${this.length(variant.sellingIncrement)}″ increments.`;
        else if (!result.validRange) this.validationEl.innerHTML = `<strong>That length is not available.</strong>This billet currently has ${this.length(this.activeVariant.length)}″ available.`;
        else this.validationEl.textContent = this.dataset.cutUnavailableMessage;
      } else this.validationEl.hidden = true;
      this.mathEl.hidden = true;
      this.mathEl.innerHTML = '';
      const totalCents = this.totalForResult(result, variant);
      this.currentTotalCents = totalCents;
      this.querySelector('[data-vf-property-price]').value = String(totalCents);
      this.querySelector('[data-vf-property-currency]').value = this.currency;
      this.totalEl.textContent = this.money.format(totalCents / 100);
      if (this.specialSavingEl) {
        const regularTotal = Math.round(result.requested * variant.regularPricePerInch + 1e-7);
        const showSaving = variant.specialPercent > 0 && regularTotal > totalCents && result.valid;
        this.specialSavingEl.hidden = !showSaving;
        this.specialSavingEl.innerHTML = showSaving
          ? `<s>${this.money.format(regularTotal / 100)}</s> · ${this.escape(this.dataset.specialSave)} ${this.money.format((regularTotal - totalCents) / 100)} (${variant.specialPercent}%)`
          : '';
      }
      this.rateEl.textContent = result.full
        ? `Full ${this.length(variant.length)}″ billet`
        : `${this.money.format(variant.pricePerInch / 100)} × ${this.length(result.requested)}″`;
      this.querySelector('[data-vf-variant-id]').value = this.activeVariant.id;
      this.querySelector('[data-vf-quantity]').value = 1;
      this.querySelector('[data-vf-property-sku]').value = this.activeVariant.sku || '';
      this.querySelector('[data-vf-property-cut-type]').value = result.full ? 'Full billet' : 'Partial cut';
      this.querySelector('[data-vf-property-length]').value = `${this.length(result.requested)} inches`;
      this.querySelector('[data-vf-property-available]').value = `${this.length(this.activeVariant.length)} inches`;
      this.querySelector('[data-vf-property-allowance]').value = result.full ? '0 inches' : `${this.length(variant.cutAllowance)} inch`;
      this.querySelector('[data-vf-property-remaining]').value = `${this.length(result.remaining)} inches`;
      this.syncMaterialWeight();
      this.syncShopifyVariant();
      this.syncDpoPrice();
      const checkoutReady = this.checkoutEnabled || this.dpoReady;
      const shippingReady = this.isShippingReady();
      const weightNotice = this.querySelector('[data-vf-weight-notice]');
      if (weightNotice) {
        weightNotice.hidden = shippingReady || !result.valid || Boolean(this.currentMaterialWeight && this.dpoLoading);
        weightNotice.querySelector('[data-vf-weight-message]').textContent = this.currentMaterialWeight
          ? this.dataset.orderingUnavailable
          : this.dataset.weightConfirmation;
      }
      this.querySelectorAll('[data-vf-submit]').forEach((button) => {
        button.disabled = !result.valid || !checkoutReady || !shippingReady;
        button.textContent = !this.currentMaterialWeight ? this.dataset.weightButton : checkoutReady ? (result.full ? window.variantStrings.addToCart.toUpperCase() : 'ADD CUT TO CART') : 'LOADING CHECKOUT…';
      });
      this.querySelector('[data-vf-note]').textContent = 'Your price is based only on the length you order.';
    }

    syncShopifyVariant() {
      if (this.pendingPurchase) return;
      const variantId = String(this.activeVariant.id);
      const inputs = this.form.querySelectorAll('[data-vf-variant-id]');
      let changed = this.syncedVariantId !== variantId;
      inputs.forEach((input) => {
        if (input.value !== variantId) changed = true;
        input.value = variantId;
      });

      if (!changed) return;
      this.syncedVariantId = variantId;
      const revision = this.variantSyncRevision = (this.variantSyncRevision || 0) + 1;

      if (window.jQuery) {
        window.jQuery(inputs).trigger('change');
      } else {
        inputs.forEach((input) => input.dispatchEvent(new Event('change', { bubbles: true })));
      }

      const finalize = () => {
        if (this.pendingPurchase || this.variantSyncRevision !== revision || String(this.activeVariant?.id) !== variantId) return;
        this.form.querySelectorAll('[data-vf-variant-id]').forEach((input) => { input.value = variantId; });
        this.syncDpoPrice();
      };
      window.setTimeout(finalize, 0);
      window.setTimeout(finalize, 150);
    }

    syncMaterialWeight() {
      this.currentMaterialWeight = window.VFMaterialWeight.calculate(this.activeVariant, this.result().requested, this.dataset.productTitle);
      const weight = this.currentMaterialWeight;
      const readable = this.querySelector('[data-vf-property-weight]');
      const raw = this.querySelector('[data-vf-property-weight-grams]');
      readable.value = weight
        ? this.dataset.weightValueTemplate.replace('[weight]', weight.pounds.toFixed(2))
        : this.dataset.weightUnavailable;
      raw.value = weight ? String(weight.grams) : '';
      raw.disabled = !weight;
      this.dataset.materialWeightGrams = weight ? String(weight.grams) : '';
      this.syncDpoWeight();
    }

    syncDpoWeight() {
      const weightInput = document.querySelector('#itoris_dynamicproductoptions .vf-weight-grams input');
      const weight = this.currentMaterialWeight;
      this.dataset.dpoWeightFieldReady = weightInput ? 'true' : 'false';
      if (!weightInput) return false;
      const value = weight ? String(weight.grams) : '';
      if (weightInput.value !== value) {
        weightInput.value = value;
        if (window.jQuery) window.jQuery(weightInput).trigger('change');
        else weightInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return Boolean(weight);
    }

    syncDpoPrice() {
      if (!window.jQuery || !this.isValid()) return false;
      this.syncDpoWeight();
      const priceInput = window.jQuery('#itoris_dynamicproductoptions .pr input');
      if (!priceInput.length) return false;
      const price = (this.currentTotalCents / 100).toFixed(2);
      if (priceInput.val() !== price) priceInput.val(price).trigger('change');
      this.dpoReady = true;
      return true;
    }

    length(value) { return Number(value || 0).toFixed(3).replace(/0+$/, '').replace(/\.$/, ''); }
    dimension(value, keepThree = false) { const number = Number(value || 0); return keepThree ? number.toFixed(3).replace(/^0/, '') : this.length(number).replace(/^0/, ''); }
    escape(value) { const div = document.createElement('div'); div.textContent = String(value ?? ''); return div.innerHTML; }
  }

  customElements.define('vf-cut-selector', VfCutSelector);
}






